import React from "react";
import { Link } from "react-router-dom";

//import components
import SidebarContent from "./SidebarContent";

//import images
import logo from "../../assets/images/whitelogo.png";
import logoLightPng from "../../assets/images/darklogo.png";
import logoLightSvg from "../../assets/images/darklogo.png";
import logoDark from "../../assets/images/whitelogo.png";

const Sidebar = (props: any) => {
  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box text-start">
          <Link to="/" className="logo logo-dark ">
            <span className="logo-sm">
              <img src={logo} alt="" style={{maxHeight: "50px"}} />
            </span>
            <span className="logo-lg">
              <img src={logoDark} alt="" style={{maxHeight: "100px"}} />
            </span>
          </Link>

          <Link to="/" className="logo logo-light text-start">
            <span className="logo-sm">
              <img src={logoLightSvg} alt="" style={{maxHeight: "50px"}} />
            </span>
            <span className="logo-lg">
              <img src={logoLightPng} alt="" style={{maxHeight: "100px"}} />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  );
};

export default Sidebar;